import { ItemAskFormData  } from "components/Form/ItemAskForm/ItemAskForm";
import { ItemAskAdditionalDataFormData } from "components/Form/ItemAskAdditionalDataForm/ItemAskAdditionalDataForm";
import { ItemAskModel } from "models";
import { JSONObject } from "models/Api/types";

export function getAskEditPayload(
  original: ItemAskModel,
  currentForm: ItemAskFormData,
  currentAdditional: ItemAskAdditionalDataFormData,
): JSONObject {
  const dirty: JSONObject = {};

  if (currentForm.askPrice && currentForm.askPrice !== original.amount) {
    dirty.amount = currentForm.askPrice;
  }

  if (currentForm.askExpiration && currentForm.askExpiration !== original.expirationDays) {
    dirty.expiration_days = currentForm.askExpiration;
  }

  if (currentAdditional.condition && currentAdditional.condition !== original.condition) {
    dirty.condition = currentAdditional.condition;
  }

  if (currentAdditional.notes && currentAdditional.notes !== original.notes) {
    dirty.notes = currentAdditional.notes;
  }

  if (currentAdditional.address && !currentAdditional.address.isEqual(original.address)) {
    dirty.address = currentAdditional.address.toObject();
  }

  if (currentAdditional.images && JSON.stringify(currentAdditional.images ?? []) !== JSON.stringify(original.images ?? [])) {
    dirty.images = currentAdditional.images;
  }

  if (currentAdditional.useEscrow !== original.useEscrow) {
    dirty.use_escrow = !!currentAdditional.useEscrow;
  }

  return dirty;
}